import React from 'react';
import StudentGoalsComingSoon from '../../components/StudentGoalsComingSoon';

const ToDo = () => (
  <StudentGoalsComingSoon />
);

export default ToDo;
